export default "__VITE_ASSET__BHF8iv86__"